import { render, staticRenderFns } from "./FMRejectRequestDialog.vue?vue&type=template&id=566114c8&"
import script from "./FMRejectRequestDialog.vue?vue&type=script&lang=js&"
export * from "./FMRejectRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports